import {
  getUser as getUserAction,
  updatePassword as updatePasswordAction,
  sendOtpToVerifyEmail as sendOtpToVerifyEmailAction,
  verifyOtpForEmailUpdation as verifyOtpForEmailUpdationAction
} from "store/user"
import { signOut as signOutAction } from "store/auth"
import { setPassword as setPasswordAction } from "store/confirm-password"

/**
 * API interface for Login & Security
 */

/**
 * High-level password change orchestrator.
 * Encapsulates branching between initial set vs update, and parses response.
 *
 * @param {Function} dispatch
 * @param {{ isPassword: boolean, current_password?: string, password: string }} payload
 * @param {Function} [t] optional i18n translator for message parsing
 * @returns {Promise<{success: boolean, message?: string, errorField?: {name: string, message: string}, didSignOut?: boolean}>}
 */
export const changePassword = async (dispatch, { isPassword, current_password, password }, t) => {
  if (!isPassword) {
    const result = await dispatch(
      setPasswordAction({
        password
      })
    )
    await dispatch(getUserAction())
    return { success: true, message: result?.message || "", didSignOut: false }
  }

  const result = await dispatch(
    updatePasswordAction({
      current_password,
      password,
      password_confirmation: password
    })
  )

  const msg = result?.message || ""
  const incorrectText = typeof t === "function" ? t("change_password.incorrect_current_password") : ""
  const isIncorrect = incorrectText ? msg.toLowerCase().includes(incorrectText.toLowerCase()) : false

  if (isIncorrect) {
    return {
      success: false,
      message: msg,
      errorField: { name: "current_password", message: msg },
      didSignOut: false
    }
  }

  await dispatch(signOutAction())
  return { success: true, message: msg, didSignOut: true }
}

/**
 * Refresh current user
 * @param {Function} dispatch
 */
export const getUser = (dispatch) => dispatch(getUserAction())

/**
 * Sign out current user
 * @param {Function} dispatch
 */
export const signOut = (dispatch) => dispatch(signOutAction())

/**
 * Send OTP to verify email
 * @param {Function} dispatch
 * @param {string} email
 */
export const sendOtpToVerifyEmail = async (dispatch, email) => {
  const result = await dispatch(sendOtpToVerifyEmailAction(email))
  return result?.message
}

/**
 * Verify OTP for email updation
 * @param {Function} dispatch
 * @param {string} email
 * @param {string} code
 */
export const verifyOtpForEmailUpdation = async (dispatch, email, code) => {
  const result = await dispatch(verifyOtpForEmailUpdationAction(email, code))
  return result?.message
}
